const SandTimerIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M12 12L17.25 6.75H6.75L12 12Z'
                fill='#827CA8'
            />
            <path
                d='M5.55929 3.75H18.4405C18.5893 3.75025 18.7345 3.7947 18.8579 3.87772C18.9813 3.96073 19.0773 4.07856 19.1335 4.21622C19.1898 4.35388 19.2039 4.50517 19.174 4.65085C19.1441 4.79653 19.0715 4.93002 18.9655 5.03438L11.9999 12L5.03429 5.03438C4.92833 4.93002 4.85579 4.79653 4.82587 4.65085C4.79596 4.50517 4.81004 4.35388 4.86631 4.21622C4.92258 4.07856 5.0185 3.96073 5.1419 3.87772C5.26529 3.7947 5.41058 3.75025 5.55929 3.75V3.75Z'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.55929 20.25H18.4405C18.5893 20.2498 18.7345 20.2053 18.8579 20.1223C18.9813 20.0393 19.0773 19.9214 19.1335 19.7838C19.1898 19.6461 19.2039 19.4948 19.174 19.3492C19.1441 19.2035 19.0715 19.07 18.9655 18.9656L11.9999 12L5.03429 18.9656C4.92833 19.07 4.85579 19.2035 4.82587 19.3492C4.79596 19.4948 4.81004 19.6461 4.86631 19.7838C4.92258 19.9214 5.0185 20.0393 5.1419 20.1223C5.26529 20.2053 5.41058 20.2498 5.55929 20.25Z'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.75 6.75H17.25'
                stroke='#827CA8'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default SandTimerIcon;
